
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"icons/checkout/review/recipient","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M19.5 0C21.985 0 24 2.095 24 4.68c0 1.723-1.5 4.496-4.5 8.32-3-3.824-4.5-6.597-4.5-8.32C15 2.095 17.015 0 19.5 0zm0 1.733c-1.13 0-2.045.97-2.045 2.167 0 1.197.915 2.167 2.045 2.167s2.045-.97 2.045-2.167c0-1.197-.915-2.167-2.045-2.167z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8 16.286c4.283 0 7.78 3.416 8 7.714H0c.22-4.298 3.717-7.714 8-7.714zM8 6c2.455 0 4.444 1.919 4.444 4.286 0 2.367-1.99 4.285-4.444 4.285-2.455 0-4.444-1.918-4.444-4.285S5.546 6 8 6z"}})])])
          )
        }
      }
    